import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotyService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';

export type ModalResult = void;
export interface ModalPublicProperties {
  certificateUrl: string;
}

@Component({
  selector: 'app-document-govbr-validate-modal',
  templateUrl: './document-govbr-validate-modal.component.html',
  styleUrls: ['./document-govbr-validate-modal.component.scss'],
  standalone: false
})
export class DocumentGovbrValidateModalComponent implements ModalPublicProperties {
  @Input() certificateUrl: string;

  constructor(
    public modal: NgbActiveModal,
    private notyService: NotyService,
    private translateService: TranslateService
  ) {}

  copyUrl(): void {
    this.notyService.success(this.translateService.instant('notyService.linkCopied'), 2000);
  }

  openValidator(): void {
    window.open('https://validar.iti.gov.br', '_blank', 'noopener,noreferrer');
  }
}
